import { Component, computed, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  FormFieldLabels,
  TextFormFieldOptions,
} from '../../../form-field.types';
import { FormFieldService } from '../../../services/form-field/form-field.service';

@Component({
  selector: 'app-checkbox-form-field',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatIconModule,
  ],
  templateUrl: './checkbox-form-field.component.html',
  styleUrl: './checkbox-form-field.component.scss',
})
export class CheckboxFormFieldComponent {
  private formFieldService = inject(FormFieldService);

  name = input('');
  labels = input<FormFieldLabels>();
  options = input<TextFormFieldOptions>();

  formGroup = this.formFieldService.formGroup;

  label = computed(() => this.labels()?.label);
  help = computed(() => this.labels()?.help);
  error = this.formFieldService.controlErrorMessage(this.name);
}
